import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
// import customTheme from "../../utils/ui";
// import DropDownPicker from 'react-native-dropdown-picker'
import { getEmirates, getRegion } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedEmirates,
  setSelectedRegion,
} from "../redux/reducers/emiratesAndRegion.reducer";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import firebase from "firebase/app";
import { Checkbox } from "@mui/material";
const Stepper = (props) => {
  const { t, i18n } = useTranslation();
  // const { userInfo, updateUserInfo , isAnonymous} = useAuthentication();
  const [stepperState, setStepperState] = useState({
    currentStep: props && props.step ? props.step : 0,
    steps: [t("emirates.emirate"), t("regions.region")],
  });
  const [loading, setLoading] = useState(false);
  const [showEmirateDdl, setShowEmirateDdl] = useState(false);
  const [showRegionDdl, setShowRegionDdl] = useState(false);
  const userData = useSelector((state) => state.auth.user);
  const selectedEmirate = useSelector(
    (state) => state.emiratesAndRegion.selectedEmirates
  );
  const selectedRegion = useSelector(
    (state) => state.emiratesAndRegion.selectedRegion
  );
  const [areasToSubmit, setAreasToSubmit] = useState(selectedRegion);
  const [emiratesToSubmit, setEmiratesToSubmit] = useState(selectedEmirate);
  const dispatch = useDispatch();

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const Emirates = [
    {
      label: t("emirates.all"),
      value: "All",
    },
    ...getEmirates(i18n.language),
  ];
  const AllRegions = [
    {
      label: t("regions.all"),
      value: "All",
    },
    ...getRegion(i18n.language),
  ];

  const [regionsList, setRegionsList] = useState([]);

  useEffect(() => {
    if (
      emiratesToSubmit &&
      emiratesToSubmit.length > 0 &&
      emiratesToSubmit.includes("All")
    ) {
      setRegionsList(AllRegions);
    } else if (emiratesToSubmit && emiratesToSubmit.length > 0) {
      let regionsFilter = AllRegions.filter((item) =>
        emiratesToSubmit.includes(item.emirate)
      );
      setRegionsList([
        {
          label: t("regions.all"),
          value: "All",
        },
        ...regionsFilter,
      ]);
    } else {
      setRegionsList(AllRegions);
    }
  }, [emiratesToSubmit]);

  const handleMultipleSelectAreas = (event) => {
    debugger;
    const item = event?.target?.value ?? [];
    const listLength =
      emiratesToSubmit.length === 0
        ? AllRegions
        : AllRegions.filter(
            (item) => emiratesToSubmit.includes(item.emirate) || item == "All"
          ).map((a) => a.value);
    const newItems =
      item?.find((area) => area === "All") &&
      item?.length > 1 &&
      item?.length < listLength.length &&
      areasToSubmit.length == 0
        ? item.filter((a) => a != "All")
        : item;
    const isAllSelected =
      newItems.find((area) => area === "All") ||
      newItems.length + 1 === listLength.length;
    const selectedList = isAllSelected ? [] : newItems;
    setAreasToSubmit(selectedList);
    setShowRegionDdl(true);
  };
  const handleMultipleSelectEmirates = (event) => {
    const item = event?.target?.value ?? [];
    const listLength = Emirates;
    const newItems =
      item?.find((emirate) => emirate === "All") &&
      item?.length > 1 &&
      item?.length < listLength.length &&
      emiratesToSubmit.length == 0
        ? item.filter((a) => a != "All")
        : item;
    const isAllSelected =
      newItems.find((emirate) => emirate === "All") ||
      newItems.length + 1 === listLength.length;
    const selectedList = isAllSelected ? [] : newItems;
    setEmiratesToSubmit(selectedList);
    setShowEmirateDdl(true);
  };

  const handleSave = async () => {
    setLoading(true);
    if (stepperState.currentStep === 0) {
      const allAreasBySelectedEmirates =
        AllRegions.filter((item) =>
          emiratesToSubmit?.includes(item.emirate)
        )?.map((item) => item.value) ?? [];
      const filteredAreas =
        areasToSubmit.filter((area) =>
          allAreasBySelectedEmirates?.includes(area)
        ) ?? [];
      dispatch(setSelectedRegion(filteredAreas));
      dispatch(setSelectedEmirates(emiratesToSubmit));
      if (!userData?.isAnonymous) {
        await firebase
          .firestore()
          .collection("users")
          .doc(userData.id)
          .update({ areas: filteredAreas, emirates: emiratesToSubmit });
      }
      setLoading(false);
      setShowRegionDdl(false);
      setShowEmirateDdl(false);
      handleClose();
    } else if (stepperState.currentStep === 1) {
      dispatch(setSelectedRegion(areasToSubmit));
      if (!userData?.isAnonymous) {
        await firebase
          .firestore()
          .collection("users")
          .doc(userData.id)
          .update({ areas: areasToSubmit });
      }
      setLoading(false);
      setShowRegionDdl(false);
      setShowEmirateDdl(false);
      handleClose();
    }
  };

  // const styles = StyleSheet.create({
  // 	centerElement: { justifyContent: 'center', alignItems: 'center' },
  // });

  return (
    <div>
      {stepperState.currentStep == 0 && (
        <div>
          <div
            onClick={() => handleSave()}
            style={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
          >
            <CancelIcon size={25} color={"#fac904"} />
            <InputLabel size={14} style={{ color: "black" }} id="close label">
              Save & Close
            </InputLabel>
          </div>
          <FormControl sx={{ m: 1, width: 300, top: 5 }}>
            <InputLabel id="demo-multiple-chip-label">Emirates</InputLabel>
            <Select
              open={showEmirateDdl}
              labelId="demo-multiple-chip-label0"
              id="demo-multiple-chip0"
              multiple
              style={{ flex: 0, borderColor: "#fac904" }}
              value={
                emiratesToSubmit.length === 0
                  ? [Emirates.find((item) => item.value == "All").value]
                  : emiratesToSubmit?.map(
                      (e) => Emirates.find((item) => item.value === e).value
                    )
              }
              disabled={loading}
              onOpen={() => setShowEmirateDdl(true)}
              onClose={() => setShowEmirateDdl(false)}
              //onSelect={handleMultipleSelectEmirates}
              onChange={handleMultipleSelectEmirates}
              input={
                <OutlinedInput
                  onClick={() => {
                    if (!loading) {
                    }
                  }}
                  id="select-multiple-chip"
                  label="Chip"
                />
              }
              renderValue={(selected) => {
                return (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => {
                      console.log("v : ", value);
                      return (
                        <Chip
                          key={value}
                          label={
                            Emirates.find((e) => e.value === value)?.label ??
                            value
                          }
                        />
                      );
                    })}
                  </Box>
                );
              }}
            >
              {Emirates.map((name) => (
                <MenuItem
                  key={name.label}
                  value={name.value}
                  style={{ justifyContent: "space-between" }}
                >
                  {name.label}
                  <Checkbox
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                    checked={(emiratesToSubmit.length === 0
                      ? [Emirates.find((item) => item.value == "All").value]
                      : emiratesToSubmit?.map(
                          (e) => Emirates.find((item) => item.value === e).value
                        )
                    )?.includes(name.value)}
                    disabled={loading}
                    style={{
                      alignSelf: "center",

                      display: "flex",
                      right: 0,
                      flexDirection: "column",
                      opacity: 1,
                    }}
                  />
                  {/* { && <CheckIcon size={10} color={"#fac904"} />} */}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}
      {stepperState.currentStep == 1 && (
        <div>
          <div
            onClick={() => handleSave()}
            style={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
          >
            <CancelIcon size={25} color={"#fac904"} />
            <InputLabel size={14} style={{ color: "black" }} id="close label">
              Save & Close
            </InputLabel>
          </div>
          <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="demo-multiple-chip-label">Areas</InputLabel>
            <Select
              labelId="demo-multiple-chip-label1"
              id="demo-multiple-chip1"
              multiple
              open={showRegionDdl}
              style={{ flex: 0, borderColor: "#fac904" }}
              value={
                areasToSubmit.length === 0
                  ? [regionsList?.find((item) => item.value === "All")?.value]
                  : areasToSubmit
              }
              //onClick={(open) => { setShowRegionDdl(open) }}
              onClose={() => setShowRegionDdl(false)}
              onOpen={() => setShowRegionDdl(true)}
              disabled={loading}
              onChange={handleMultipleSelectAreas}
              input={
                <OutlinedInput
                  onClick={() => {
                    if (!loading) {
                    }
                  }}
                  id="select-multiple-chip"
                  label="Chip"
                />
              }
              renderValue={(selected) => {
                return (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={
                          regionsList?.find((e) => e.value === value)?.label ??
                          value
                        }
                      />
                    ))}
                  </Box>
                );
              }}
            >
              {regionsList?.map((name) => (
                <MenuItem
                  key={name.label}
                  value={name.value}
                  style={{ justifyContent: "space-between" }}
                >
                  {name.label}
                  {/* (emiratesToSubmit.length === 0 ? [Emirates.find(item => item.value == "All").value] : emiratesToSubmit?.map((e) => Emirates.find(item => item.value === e).value))?.includes(name.value) */}
                  {/* (areasToSubmit.length === 0 ? [regionsList?.find(item => item.value === "All")?.value] : areasToSubmit)?.includes(name.value) */}
                  <Checkbox
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                    checked={(areasToSubmit.length === 0
                      ? [regionsList.find((item) => item.value == "All").value]
                      : areasToSubmit?.map(
                          (e) =>
                            regionsList.find((item) => item.value === e).value
                        )
                    )?.includes(name.value)}
                    disabled={loading}
                    style={{
                      alignSelf: "center",

                      display: "flex",
                      right: 0,
                      flexDirection: "column",
                      opacity: 1,
                    }}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}
    </div>
  );
};

export default Stepper;
